import { render } from "./variable-menu-button.vue?vue&type=template&id=7bad3a5a&scoped=true"
import script from "./variable-menu-button.vue?vue&type=script&lang=js"
export * from "./variable-menu-button.vue?vue&type=script&lang=js"

import "./variable-menu-button.vue?vue&type=style&index=0&id=7bad3a5a&scoped=true&lang=scss"
import "./variable-menu-button.vue?vue&type=style&index=1&id=7bad3a5a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bad3a5a"]])

export default __exports__